import {
  UPDATE_APPLE_PAY_AVAILABLE,
  UPDATE_GOOGLE_PAY_AVAILABLE,
  API_CALL,
  TOGGLE_SHOW_MARGIN_IN_SPOOF_MODE,
  TOGGLE_CONCIERGE_MODE,
  DISMISS_LUX_PLUS_FREE_PREVIEW_BANNER,
  HOTEL_CANCELLATION_PRICE_CHANGE_MODAL_SEEN,
  DISMISS_BETA_TRIP_BANNER,
} from './actionConstants'
import { FETCH_MERCHANT_FEE_CONFIG, FETCH_PAYTO_SUPPORTED_BANKS, FETCH_DEPOSIT_CONFIG, FETCH_PAYPAL_SETTINGS, FETCH_LAB_REMOTE_CONFIG } from './apiActionConstants'
import { getMerchantFeeConfig, getPayToSupportedBanks, getDepositConfig, getPayPalSettings } from 'api/payment'
import { getRemoteConfigFlags } from 'api/lab'
import { setDismissed as cookieDismiss } from 'luxPlus/cookies/freePreviewBanner'
import { setMarginInSpoofModeCookie } from 'cookies/showMarginInSpoofMode'
import { setConciergeModeCookie } from 'cookies/conciergeMode'
import { AppAction } from './types/ActionTypes'
import { betaAiTripBannerDismissed } from 'tripPlanner/cookies/betaAiTripBanner'

export function updateCanPayWithApplePay(flag: boolean): AppAction {
  return (dispatch, getState) => {
    const state = getState()
    if (state.system.canPayWithApplePay === flag) {
      // value won't change, don't need to send an action
      return
    }

    dispatch({
      type: UPDATE_APPLE_PAY_AVAILABLE,
      value: flag,
    })
  }
}

export function updateCanPayWithGooglePay(flag: boolean): AppAction {
  return (dispatch, getState) => {
    const state = getState()
    if (state.system.canPayWithGooglePay === flag) {
      // value won't change, don't need to send an action
      return
    }

    dispatch({
      type: UPDATE_GOOGLE_PAY_AVAILABLE,
      value: flag,
    })
  }
}

export function fetchMerchantFeeConfig(): AppAction {
  return (dispatch, getState) => {
    const { system } = getState()
    if (system.merchantFeeConfigs.length !== 0) return

    dispatch({
      type: API_CALL,
      api: FETCH_MERCHANT_FEE_CONFIG,
      request: () => getMerchantFeeConfig(),
    })
  }
}

export function fetchPayToSupportedBanks(): AppAction {
  return (dispatch, getState) => {
    const { system } = getState()
    if (system.payToSupportedBanks.length !== 0) return

    dispatch({
      type: API_CALL,
      api: FETCH_PAYTO_SUPPORTED_BANKS,
      request: () => getPayToSupportedBanks(),
    })
  }
}

export function fetchDepositConfig(): AppAction {
  return (dispatch, getState) => {
    const { system } = getState()
    if (system.depositConfigs) return

    dispatch({
      type: API_CALL,
      api: FETCH_DEPOSIT_CONFIG,
      request: () => getDepositConfig(),
    })
  }
}

export function fetchPayPalSettings(): AppAction {
  return (dispatch, getState) => {
    const { system } = getState()
    if (system.payPalSettings) return

    dispatch({
      type: API_CALL,
      api: FETCH_PAYPAL_SETTINGS,
      request: () => getPayPalSettings(),
    })
  }
}

export function fetchLabRemoteConfig(keys: Array<string>): AppAction {
  return (dispatch) => {
    dispatch({
      type: API_CALL,
      api: FETCH_LAB_REMOTE_CONFIG,
      request: () => getRemoteConfigFlags(keys),
    })
  }
}

export function toggleShowMarginInSpoofMode(): AppAction {
  return (dispatch, getState) => {
    const state = getState()
    const showMarginInSpoofMode = state.system.showMarginInSpoofMode
    setMarginInSpoofModeCookie(!showMarginInSpoofMode)
    dispatch({
      type: TOGGLE_SHOW_MARGIN_IN_SPOOF_MODE,
      showMarginInSpoofMode: !showMarginInSpoofMode,
    })
  }
}

export function toggleConciergeMode(): AppAction {
  return (dispatch, getState) => {
    const state = getState()
    const conciergeMode = state.system.conciergeMode
    setConciergeModeCookie(!conciergeMode)
    dispatch({
      type: TOGGLE_CONCIERGE_MODE,
      conciergeMode: !conciergeMode,
    })
  }
}

export function dismissFreePreviewBanner(): AppAction {
  cookieDismiss()
  return {
    type: DISMISS_LUX_PLUS_FREE_PREVIEW_BANNER,
  }
}

export function dismissBetaTripBanner(): AppAction {
  betaAiTripBannerDismissed()
  return {
    type: DISMISS_BETA_TRIP_BANNER,
  }
}

export function hotelCancellationPriceChangeModalSeen(): AppAction {
  return {
    type: HOTEL_CANCELLATION_PRICE_CHANGE_MODAL_SEEN,
  }
}
